export const SIGN_UP_EMAIL_ADDRESS = "SIGN_UP_EMAIL_ADDRESS";
export const DAILY_ASSESSMENT_VIEWED = "DAILY_ASSESSMENT_VIEWED";
export const DAILY_ASSESSMENT_COMPLETED = "DAILY_ASSESSMENT_COMPLETED";